import { Module } from 'vuex';

import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export const state: Store.StarWars.ProtagonistState = {
  protagonist: {
    name: '',
  },
};

const namespaced = true;

export const starWars: Module<Store.StarWars.ProtagonistState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
